import { ImageConfig } from '@aboutyou/legacy-shared/src/types/images'
import React, { createContext, FC, useContext } from 'react'

interface ProductTileImageSizeContextValue {
  defaultImageWidth: ImageConfig['width']
  imageWidths: ImageConfig['width'][]
  imageSizes: string[]
}

const edgePaddingWide = '60px'
const edgePaddingNarrow = '20px'
const sideBarNavWidth = '13vw'
const gutterWidth = 'calc(2.7vw + 5px)'
const productTileMargin = '2px'
const tileSizes = [
  '(min-width: 1920px) 360px',
  `(min-width: 1280px) calc((100vw - (${edgePaddingWide} * 2) - ${sideBarNavWidth} - ${gutterWidth} - ${gutterWidth} - (${productTileMargin} * 3)) / 4)`,
  `(min-width: 1024px) calc((100vw - (${edgePaddingNarrow} * 2) - ${sideBarNavWidth} - ${gutterWidth} - ${gutterWidth} - (${productTileMargin} * 2)) / 3)`,
  `(min-width: 768px) calc((100vw - (${edgePaddingNarrow} * 2) - ${sideBarNavWidth} - ${gutterWidth} - ${gutterWidth} - ${productTileMargin}) / 2)`,
  '290px',
]

const ProductTileImageSizeContext =
  createContext<ProductTileImageSizeContextValue>({
    defaultImageWidth: 400,
    imageWidths: [220, 400],
    imageSizes: tileSizes,
  })

export const ProductTileImageSizeContextProvider: FC<
  React.PropsWithChildren<ProductTileImageSizeContextValue>
> = ({ defaultImageWidth, imageWidths, imageSizes, children }) => {
  const productTileImageSizeContext = {
    defaultImageWidth,
    imageWidths,
    imageSizes,
  }

  return (
    <ProductTileImageSizeContext.Provider value={productTileImageSizeContext}>
      {children}
    </ProductTileImageSizeContext.Provider>
  )
}

export const useProductTileImageSizes = () =>
  useContext(ProductTileImageSizeContext)
